import { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';
import { Layout } from './components/Layout';

/**
 * React Router doesn't reset scroll on navigation by default. Without this,
 * clicking "Book a Trial" from a footer link drops the user mid-page on the
 * trial route. Reset to the top whenever the path changes.
 */
function ScrollToTopOnNavigate() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname]);
  return null;
}
import { HomePage } from './pages/HomePage';
import { TrialPage } from './pages/TrialPage';
import { TrialSuccessPage } from './pages/TrialSuccessPage';
import { JoinPage } from './pages/JoinPage';
import { JoinSuccessPage } from './pages/JoinSuccessPage';
import { ProgramsPage } from './pages/ProgramsPage';
import { ProgramCardLabPage } from './pages/ProgramCardLabPage';
import { SchedulePage } from './pages/SchedulePage';
import { ContactPage } from './pages/ContactPage';
import { LocationPage } from './pages/LocationPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { AccountPage } from './pages/AccountPage';
import { AdminIdPage } from './pages/AdminIdPage';
import { WaiverViewerPage } from './pages/WaiverViewerPage';

export function App() {
  return (
    <Layout>
      <Analytics />
      <ScrollToTopOnNavigate />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/trial" element={<TrialPage />} />
        <Route path="/trial/success" element={<TrialSuccessPage />} />
        <Route path="/trial-signup/success" element={<TrialSuccessPage />} />
        <Route path="/join" element={<JoinPage />} />
        <Route path="/join/success" element={<JoinSuccessPage />} />
        <Route path="/programs" element={<ProgramsPage />} />
        <Route path="/program-card-lab" element={<ProgramCardLabPage />} />
        <Route path="/schedule" element={<SchedulePage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/location" element={<LocationPage />} />
        <Route path="/account" element={<AccountPage />} />
        <Route path="/admin/users/:userId/id" element={<AdminIdPage />} />
        <Route path="/waiver/:id" element={<WaiverViewerPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Layout>
  );
}
